var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.5C7.067 5.5 5.5 7.067 5.5 9V13.25H9.26789L11.1921 7.75224C11.2974 7.45142 11.5813 7.25 11.9 7.25C12.2187 7.25 12.5026 7.45142 12.6079 7.75224L16.1 17.7297L17.4921 13.7522C17.5974 13.4514 17.8813 13.25 18.2 13.25H22.5V9C22.5 7.067 20.933 5.5 19 5.5H9ZM22.5 14.75H18.7321L16.8079 20.2478C16.7026 20.5486 16.4187 20.75 16.1 20.75C15.7813 20.75 15.4974 20.5486 15.3921 20.2478L11.9 10.2703L10.5079 14.2478C10.4026 14.5486 10.1187 14.75 9.8 14.75H5.5V19C5.5 20.933 7.067 22.5 9 22.5H19C20.933 22.5 22.5 20.933 22.5 19V14.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrend);
export default __webpack_public_path__ + "static/media/ic-trend.6957437446ad103f3b09c97cb26f192b.svg";
export { ForwardRef as ReactComponent };